import React from 'react';
import { IonContent, IonPage } from '@ionic/react';
import AppHeader from '../components/AppHeader';
import { RouteComponentProps } from 'react-router-dom';

interface RGPDProps
  extends RouteComponentProps<{
    id: string;
  }> {}

const RGPD: React.FC<RGPDProps> = ({ match }) => {
  return (
    <IonPage className="news-single">
      <AppHeader defaultBackLink="/dashboard/" />
      <IonContent>
        <div className="wrapper wrapper--large">
          <div className="ion-padding">
            <div className="ion-text-content">
              <h1>
                <span property="schema:name">Protection des données</span>
              </h1>

              <div property="schema:text">
                <h2>Déclaration publique</h2>

                <p>
                  Chez Unilabs, nous avons toujours à l’esprit de mener à bien
                  et au mieux notre mission, comme l’indique notre devise CARE
                  BIG, et notre culture d’entreprise s’attache à protéger ce qui
                  est le plus précieux pour nos clients, notamment leurs données
                  personnelles, qui sont toujours entourées du niveau de
                  sécurité le plus élevé dans notre entreprise. Nous appliquons
                  depuis toujours la réglementation en matière de protection des
                  données.
                  <br />
                  La mise en œuvre du nouveau règlement de l’UE en matière de
                  protection des données – Règlement général de protection des
                  données (RGPD) – impose un nouvel ensemble de règles
                  qu’Unilabs applique.
                </p>

                <h2>1. Unilabs et le RGPD</h2>

                <p>
                  Chaque fois que des données à caractère personnel sont
                  confiées à l’une de nos entreprises, nous nous imposons de
                  répondre strictement aux dispositions du RGPD. Cela s’applique
                  au traitement des données des patients, mais également à
                  celles de nos salariés, clients, fournisseurs, partenaires
                  commerciaux et autres personnes avec lesquelles nous
                  entretenons des relations de travail dans le cadre de notre
                  activité.
                  <br />
                  Nous avons analysé le RGPD avec l’assistance d’une entreprise
                  de premier plan en matière de protection de données et
                  constitué une équipe de protection des données avec à sa tête
                  un Responsable Protection des données du Groupe.
                  <br />
                  Traitement des données - Le RGPD exige que les données à
                  caractère personnel soient collectées et traitées de façon
                  juste pour des finalités définies, explicites et légitimes.
                  Nos opérations de traitement des données sont inscrites dans
                  un registre, et chacune repose sur une base juridique claire.
                  Par exemple, une opération de traitement peut être nécessaire
                  pour l’exécution d’un contrat, ou pour des besoins légitimes
                  d’Unilabs. Nous sommes particulièrement attentifs lorsque nous
                  faisons appel à des sous-traitants pour assurer le traitement
                  de données à caractère personnel que nous leur confions, et
                  nous veillons à ce qu’ils soient liés par des procédures de
                  contrôle préalable et des accords contractuels.
                  <br />
                  Transparence - Le RGPD exige que les données à caractère
                  personnel soient en permanence sous contrôle pendant toute
                  leur vie utile, et la mise en œuvre de mesures pour s’assurer
                  qu’elles sont appropriées, pertinentes, limitées, exactes et à
                  jour. Nous sommes pleinement transparents quant à la façon
                  dont nos établissements traitent les données à caractère
                  personnel. Notre organisation assure la collecte, la
                  conservation, l’utilisation, la modification ou l’effacement
                  de toutes les données à caractères personnel conformément au
                  RGPD et aux demandes des personnes concernées.
                  <br />
                  Sécurité des données - La sécurité des données est de la plus
                  haute importance pour Unilabs. Nous mettons en œuvre toutes
                  les mesures techniques et organisationnelles pour assurer le
                  niveau de sécurité le plus élevé et pour que les données à
                  caractère personnel soient accessibles et protégées.
                  <br />
                  Vous pouvez lire également à ce sujet notre document FAQ sur
                  le RGPD pour plus d’indication sur notre position au regard de
                  la nouvelle réglementation.
                </p>

                <p>Et à l’avenir ?</p>

                <p>
                  Nous faisons de notre mieux chez Unilabs pour apporter aux
                  clients une expérience unique. Nous allons continuer à
                  apporter les changements opérationnels requis par l’évolution
                  de la législation et nous en tiendrons informés nos clients,
                  nos patients, nos fournisseurs et les autorités de contrôle.
                </p>

                <p>
                  Le RGPD est l’opportunité parfaite de renforcer notre
                  collaboration avec les organismes de santé afin d’améliorer
                  les soins apportés aux personnes qui nous confient la
                  protection de leurs données à caractère personnel.
                  <br />
                  Pour en savoir plus sur le RGPD, vous pouvez consulter le site
                  de la Commission européenne :&nbsp;
                  <a href="https://ec.europa.eu/info/law/law-topic/data-protection/data-protection-eu_en">
                    https://ec.europa.eu/info/law/law-topic/data-protection/data-protection-eu_en
                  </a>
                  .
                </p>

                <p>
                  Pour plus informations sur notre conformité au RGPD, vous
                  pouvez nous contacter à notre adresse mail&nbsp;
                  <a href="mailto:dpo@unilabs.com">dpo@unilabs.com</a>
                </p>

                <h2>2. Notifications d’informations</h2>

                <p>
                  Le RGPD exige des responsables du traitement qu’ils
                  fournissent aux personnes concernées des informations sur le
                  traitement auquel ils procèdent et les questions y afférentes,
                  ainsi que sur les droits des personnes concernées, de manière
                  succincte, transparente, claire et facile d’accès, en
                  utilisant un langage simple.
                </p>

                <ul>
                  <li>
                    <a href="https://unilabs.fr/node/1449">
                      Notice d'information Unilabs aux Patients
                    </a>
                  </li>
                  <li>
                    <a href="https://unilabs.fr/node/1450">
                      Notice d'information Unilabs aux Professionnels de Santé
                    </a>
                  </li>
                  <li>
                    <a href="https://unilabs.fr/node/1446">
                      Notice d'information Unilabs aux Candidats
                    </a>
                  </li>
                  <li>
                    <a href="https://unilabs.fr/node/1447">
                      Notice d'information Unilabs aux Fournisseurs
                    </a>
                  </li>
                  <li>
                    <a href="https://unilabs.fr/node/1448">
                      Notice d'information Unilabs aux Journalistes
                    </a>
                  </li>
                  <li>
                    <a href="https://unilabs.fr/node/1451">
                      Notice d'information Unilabs aux Visiteurs internet
                    </a>
                  </li>
                </ul>

                <h2>3. Informations sur vos droits</h2>

                <p>
                  3.1 Accès.&nbsp;Vous avez le droit de demander si nous
                  traitons des données à caractère personnel vous concernant et
                  de demander à y avoir accès.
                </p>

                <p>
                  Vous avez également le droit de connaître les raisons pour
                  lesquelles nous recueillons ces données et la manière dont
                  nous les traitons, ainsi que le type de données à caractère
                  personnel que nous traitons, les organisations qui les
                  reçoivent et la façon dont ces données sont stockées.
                </p>

                <p>
                  3.2 Opposition au traitement.&nbsp;Vous avez le droit de vous
                  opposer au traitement de données à caractère personnel eu
                  égard à vos intérêts légitimes. Toutefois, si les motifs qui
                  nous animent sont légitimes et irréfutables, et s’ils priment
                  sur vos intérêts, vos droits et vos libertés, il se peut que
                  nous soyons en droit de poursuivre le traitement. Lorsque le
                  traitement procède d’un consentement, vous pouvez retirer le
                  consentement que vous avez donné à l’utilisation de vos
                  données à caractère personnel par Unilabs. Ceci n’affectera
                  pas l’utilisation des informations vous concernant avant le
                  retrait de ce consentement.
                </p>

                <p>
                  3.3 Opposition au traitement à des fins de prospection
                  directe.&nbsp;Vous avez toujours le droit de vous opposer à ce
                  que nous traitions des données à caractère personnel vous
                  concernant dans un but de prospection commerciale directe.
                </p>

                <p>
                  3.4 Rectification.&nbsp;Vous êtes en droit de demander la
                  rectification de données à caractère personnel inexactes ou
                  incomplètes, la limitation du traitement auquel nous procédons
                  et la finalisation des données à caractère personnel
                  incomplètes.
                </p>

                <p>
                  3.5 Effacement.&nbsp;Vous avez aussi le droit de demander que
                  les données à caractère personnel vous concernant soient
                  supprimées dans certaines circonstances, comme, par exemple,
                  lorsque ces informations ne sont plus nécessaires.&nbsp;
                </p>

                <p>
                  3.6 Limitation du traitement.&nbsp;Vous êtes en droit de
                  demander que le traitement des données à caractère personnel
                  vous concernant soit limité. Il se peut que nous ne soyons pas
                  en mesure de vous fournir nos services tant que ce traitement
                  est sujet à limitation.
                </p>

                <p>
                  3.7 Portabilité des données.&nbsp;Dans certaines
                  circonstances, vous avez le droit d’avoir accès à vos données
                  à caractère personnel sous un format structuré, couramment
                  utilisé et lisible par une machine (portabilité des données)
                  et de transmettre ces données à un autre responsable de
                  traitement. Ce droit est limité aux données à caractère
                  personnel que vous nous avez transmises, si le traitement dont
                  elles font l’objet a pour but d’honorer un contrat conclu avec
                  vous ou s’appuie sur votre consentement.&nbsp;
                </p>

                <p>
                  3.8&nbsp;Si vous avez des questions concernant le traitement
                  auquel nous soumettons vos données à caractère personnel,
                  n’hésitez pas à nous contacter. Vous trouverez nos coordonnées
                  au paragraphe 1.2 ci-dessus. Au cas où vous souhaiteriez
                  formuler une réclamation sur la manière dont nous assurons le
                  traitement des données à caractère personnel vous concernant,
                  vous pouvez le faire auprès de l’Autorité de Protection des
                  Données.
                </p>

                <h2>4. Cookies</h2>

                <p>
                  4.1&nbsp;Unilabs utilise des cookies pour recevoir et
                  enregistrer des informations, et nous pouvons aussi recourir à
                  d’autres technologies à cet effet (« Collecte Automatique de
                  Données »). Ceci peut comprendre des informations personnelles
                  collectées à partir de votre navigateur. Lorsque nous recevons
                  ces informations, nous observons la loi relative aux
                  communications électroniques (SFS 2003:389).
                </p>

                <p>
                  4.2&nbsp;En quelques mots, les cookies sont de petits fichiers
                  texte qui sont envoyés vers votre navigateur sur votre
                  ordinateur, votre téléphone portable ou tout autre dispositif
                  technique que vous utilisez. Les cookies servent à stocker des
                  informations sur cet appareil et ils fonctionnent comme une
                  mémoire, ce qui veut dire que lorsque vous visitez à nouveau
                  le site, celui-ci se souvient de votre appareil.
                  <br />
                  Il existe deux types de cookies : les cookies de session et
                  les cookies persistants. Les premiers durent seulement jusqu’à
                  la fermeture de votre session de navigation sur l’appareil,
                  tandis que les seconds perdurent pendant une durée déterminée
                  plus longue.
                </p>

                <p>
                  4.3&nbsp;Les informations collectées par les cookies peuvent
                  comprendre ce qui suit :
                </p>

                <ul>
                  <li>Géolocalisation</li>
                  <li>
                    Moment de la consultation, pages consultées, et temps passé
                    sur chaque page du site
                  </li>
                  <li>
                    Coordonnées du site référent (tel que le lien URI via lequel
                    l’utilisateur est parvenu au site)
                  </li>
                  <li>
                    <span>
                      <span>Domaine, type de navigateur et langue</span>
                    </span>
                  </li>
                  <li>Pays et fuseau horaire</li>
                  <li>Comportement de navigation</li>
                  <li>
                    <span>
                      <span>Type de système d’exploitation (OS)</span>
                    </span>
                  </li>
                  <li>
                    Version Flash, support JavaScript, capacité de traitement
                    selon la résolution d’écran et la couleur d’écran
                  </li>
                  <li>
                    <span>
                      <span>Emplacement du réseau et adresse IP</span>
                    </span>
                  </li>
                  <li>Téléchargements de documents</li>
                  <li>Clics sur des liens vers des sites internet externes</li>
                  <li>
                    Erreurs lorsque les utilisateurs remplissent des formulaires
                  </li>
                  <li>Clics sur des vidéos</li>
                  <li>Profondeur du défilement</li>
                  <li>
                    Interactions avec des applications (widgets) propres au site
                  </li>
                </ul>
                <p>
                  4.4&nbsp;Unilabs a recours à des cookies pour recevoir des
                  informations sur l’utilisation du site internet. Ces
                  informations nous aident à améliorer notre site et nos
                  services. En général, vous pouvez changer les paramètres de
                  votre navigateur pour désactiver tous les cookies, refuser les
                  nouveaux cookies ou faire en sorte que votre appareil vous
                  signale l’envoi de nouveaux cookies.
                </p>

                <p>
                  4.5&nbsp;Pour modifier les cookies, servez-vous des paramètres
                  du navigateur. Chaque navigateur web est particulier, mais
                  vous pouvez toujours utiliser le menu d’Aide de celui-ci pour
                  apprendre à modifier vos cookies. Cette modification doit être
                  effectuée sur tous les navigateurs que vous utilisez si vous
                  voulez que tous vos paramètres de cookies soient les mêmes.
                  Vous devez savoir que si vous désactivez vos cookies, il se
                  peut que certains des services du site ne fonctionnent pas
                  correctement.
                </p>

                <p>
                  4.6&nbsp;Les informations qui peuvent être utilisées pour
                  identifier des utilisateurs du site internet seront divulguées
                  à des tiers (Google Analytics). Les informations qui ne
                  peuvent être rattachées à l’identité d’un utilisateur peuvent
                  être divulguées. La durée pendant laquelle les informations
                  obtenues grâce aux cookies sont stockées dépend de la
                  fréquence de vos consultations du site internet.&nbsp;Il est
                  conseillé de préciser également les cookies qui sont utilisés
                  en pratique (le nom des cookies). Il existe un projet de
                  nouveau règlement de l’UE (autre que le RGPD) qui réglemente,
                  entre autres, l’utilisation des cookies, et qui pourrait
                  engendrer une approche différente. Toutefois, il n’a pas
                  encore été approuvé et la date de son entrée en vigueur reste
                  incertaine.
                </p>

                <h2>5. Autres questions</h2>

                <p>
                  Unilabs vous invite à nous contacter si vous avez d’autres
                  questions à propos de la présente Police. Vous pourrez trouver
                  nos coordonnées au paragraphe 2 ci-dessus.
                </p>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default RGPD;
